import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { ImagesEntity } from '@galabid/gb-dashboard/shared/data-access-images'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { FONT_FAMILY_OPTIONS } from '../presenter-tools-options'

@Component({
  selector: 'gb-presenter-tools-canvas',
  imports: [
    GbDashboardSharedUiModule,
    MatSlideToggleModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
  templateUrl: './gb-presenter-tools-canvas.component.html',
  styleUrl: './gb-presenter-tools-canvas.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsCanvasComponent {
  @Input() backgroundColorFormControl!: FormControl
  @Input() backgroundImages: ImagesEntity[] | null | undefined = []
  @Input() backgroundImageCover: boolean | null | undefined = true
  @Input() fontColorFormControl!: FormControl
  @Input() fontFamilyFormControl!: FormControl

  @Output() backgroundColorChange = new EventEmitter<string>()

  @Output() openBackgroundImageUploadDialog = new EventEmitter<void>()
  @Output() clearBackgroundImage = new EventEmitter<void>()

  @Output() backgroundImageCoverChange = new EventEmitter<boolean>()

  @Output() fontColorChange = new EventEmitter<string>()
  @Output() fontFamilyChange = new EventEmitter<string>()

  fontFamilyOptions = FONT_FAMILY_OPTIONS
}
